import { useParams } from "react-router-dom";
import { TagGifListMemo as TagGifList } from "components/feed/TagGifList";
import { Fragment, useEffect, useState } from "react";
import { useMatchedTagsQuery } from "queries";
import "../common.scss";
import "./TagPage.scss";
import { ContentPageSkyscraperEnum } from "components/ads/config/units/contentPageSkyscraper";
import { WithSideAds } from "components/ads";
import { FooterAds } from "components/ads/FooterAds";

export const TagPage = () => {
  const { tag } = useParams();
  const [tagName, setTagName] = useState("");

  const { status, data } = useMatchedTagsQuery({
    query: tag ?? ""
  });

  useEffect(() => {
    if (status === "success" && data.length) {
      setTagName(data.join(" + "));
    }
  }, [status, data]);

  if (tag === undefined) {
    return <p>Error loading page.</p>;
  }

  document.title = `${tagName} Porn GIFs and Pics | RedGIFs`;

  return (
    <Fragment>
      <WithSideAds
        leftAds={[
          ContentPageSkyscraperEnum.ContentPageSkyscraperL1,
        ]}
        rightAds={[
          ContentPageSkyscraperEnum.ContentPageSkyscraperR1,
        ]}
      >
        <div className="wide page tagPage">
          <TagGifList tag={tag} tagName={tagName} />
        </div>
      </WithSideAds>

      <FooterAds/>
    </Fragment>
  );
};
